import { API_BASE_URL, API_CREATE_APP_USER } from '../../consts';
import axios from "axios";
import refreshAccessToken from './refreshAccessToken';


export type ResultDetail = {
    [key: string]: boolean[]; // Keys like "hard-heard", "cat-cut", etc., and their boolean arrays
};

export type appUserInfo = {
    studentName: string,
    email: string,
    classRoomName: string,
    password: string,
    role: string
};

export type getCreateAppUserReponse = {
    status: string,
    message: string
};


async function executeGetCreateAppUserWithToken(accessToken: string | null, appUserInfo: appUserInfo): Promise<getCreateAppUserReponse> {
    return axios
        .post(
            API_BASE_URL + API_CREATE_APP_USER,
            {
                studentName: appUserInfo.studentName,
                email: appUserInfo.email,
                classRoomName: appUserInfo.classRoomName,
                password: appUserInfo.password,
                role: appUserInfo.role
            },
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            }
        )
        .then(response => {
            if (response.status === 201) {
                return Promise.resolve(response.data);
            }
            throw new Error("Unexpected response status or missing data");
        })
        .catch(error => {
            if (error.response && error.response.status === 400) {
                console.log("Missing required fields");
            } else if (error.response && error.response.status === 403) {
                console.log("Missing required role");
            } else if (error.response && error.response.status === 404) {
                console.log("Classroom does not exist.");
            } else {
                console.error('Error during creation:', error);
            }
            return Promise.reject(error);
        });
}


export default async function autoRefreshedExecuteGetCreateAppUserWithToken(accessToken: string | null, appUserInfo: appUserInfo): Promise<getCreateAppUserReponse> {

    return executeGetCreateAppUserWithToken(accessToken, appUserInfo)
        .catch(error => {
            if (error.response.status == 401) {
                return refreshAccessToken().then(refreshedAccessToken => {
                    if (refreshedAccessToken) {
                        console.log("refreshed");
                        return executeGetCreateAppUserWithToken(accessToken, appUserInfo);
                    } else {
                        throw error;
                    }
                });
            }
            throw error;
        });
}
